import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getSeason, postTeamRegister } from "../../api";
import { Season } from "../../types/season";
import styles from "./index.module.scss";
import { Loading, Modal, Notification } from "@quark/design";
import Navigator from "../../component/navigator";
import { isExpired } from "../../utils/date";
import useDocumentTitle from "../../hooks/use-document-title";
import { useKV } from "@quark/kits";

const SeasonPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { seasonId = 1 } = params;
  const [season, setSeason] = useState<Season.Season>();
  const [team, setTeam] = useState<Season.Team>();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showTeamInfo, setShowTeamInfo] = useState(false);
  const match = useMemo(() => {
    return season?.matches?.[0];
  }, [season]);
  useDocumentTitle("打卡");
  const { data: teacherQrcode } = useKV("teacher");

  const register = () => {
    if (!season || !match) {
      Notification.error("参数有误", { duration: 3000 });
      return;
    }
    if (isExpired(season.apply_end_time)) {
      Notification.error("报名已截止, 请留意下期时间", { duration: 4000 });
      return;
    }
    if (submitting) return;
    if (team) {
      setShowTeamInfo(true);
      return;
    }
    setSubmitting(true);
    postTeamRegister(season.id, match.id)
      .then((team) => {
        Notification.success("报名成功", { duration: 3000 });
        setTeam(team);
        setShowTeamInfo(true);
      })
      .catch((err) => {
        Notification.error(err.msg, { duration: 3000 });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    const id = Number(seasonId);
    setLoading(true);
    getSeason(id)
      .then((res) => {
        setSeason(res);
        if (res.my_team) {
          setTeam(res.my_team);
          setShowTeamInfo(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [seasonId]);

  useEffect(() => {
    if (team?.status === "pass") {
      navigate(`/season/${seasonId}/tasks`);
    }
  }, [team, seasonId, navigate]);

  if (loading) return <Loading />;

  return (
    <>
      {!!season && (
        <div className={styles.container}>
          <Navigator />
          <div className={styles.content}>
            <div className={styles.season}>
              <img className={styles.cover} src={season.cover} alt="" />
              {!team && (
                <div className={styles.footer}>
                  <div className={styles.desc}>免费参与&nbsp;赚奖学金</div>
                  <div className={styles.button} onClick={register}>
                    {submitting ? <Loading /> : "立即报名"}
                  </div>
                </div>
              )}

              {!!team && (
                <Modal
                  visible={showTeamInfo}
                  title="参与活动"
                  draggable
                  onClose={() => setShowTeamInfo(false)}
                >
                  <div className={styles.card}>
                    <div className={styles.line}>
                      🆚 参与码:{" "}
                      <span className={styles.code}>{team.auth_code}</span>
                    </div>
                    <div className={styles.line}>
                      🥇 还差一步，添加老师，截图或复制【参与码】
                      发送老师，即可参加活动
                    </div>
                    <div className={styles.qrcode}>
                      <img src={teacherQrcode?.value} alt="" />
                    </div>
                  </div>
                </Modal>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SeasonPage;
